import React from 'react';
import WebLayout from '../layouts/WebLayout';

const PromotionPartnerPage = () => {
    return (
        <WebLayout>
            <div className="min-h-screen bg-white">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
                    {/* 메인 타이틀 */}
                    <div className="text-center mb-20">
                        <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
                            함께 만들어요, <span className="text-amber-500">건강한 식사문화</span>
                        </h1>
                    </div>

                    {/* 1행 - 대학교 제휴와 학생회 제휴 */}
                    <div className="grid md:grid-cols-2 gap-12 mb-20">
                        <div className="space-y-6">
                            <h2 className="text-3xl font-bold text-amber-500">대학교 제휴</h2>
                            <p className="text-lg text-gray-700 leading-relaxed">
                                밥친구는 대학과 함께<br/>
                                학생 복지와 정서적 건강, 지역 상생을 목표로<br/>
                                식사 지원 프로그램과 공공형 모임 캠페인을 운영해요.
                            </p>
                        </div>
                        <div className="space-y-6">
                            <h2 className="text-3xl font-bold text-amber-500">학생회 제휴</h2>
                            <p className="text-lg text-gray-700 leading-relaxed">
                                밥친구는 대학 캠퍼스를 중심으로<br/>
                                혼밥 해소, 연결 회복, 지역 상권 연계라는 목표를 가지고<br/>
                                각 학교 학생회와 협약을 맺고 특별한 참여 혜택을 제공해요
                            </p>
                        </div>
                    </div>

                    {/* 2행 - 학교 적응도 */}
                    <div className="grid md:grid-cols-2 gap-12 items-center mb-20">
                        <div className="space-y-6">
                            <h2 className="text-3xl font-bold text-amber-500">학교 적응도, 밥친구 모임으로</h2>
                            <p className="text-lg text-gray-700 leading-relaxed">
                                밥친구는 낯선 캠퍼스 생활 속에서<br/>
                                처음 만난 친구들과 자연스럽게 식사할 기회를 만들어줘요
                            </p>
                        </div>
                        <div className="aspect-[4/3] rounded-lg overflow-hidden">
                            <img 
                                src="/images/web2_3.png" 
                                alt="학교 중심 모임 이미지" 
                                className="w-full h-full object-cover"
                            />
                        </div>
                    </div>

                    {/* 3행 - 제휴 대학 목록 */}
                    <div className="text-center mb-20">
                        <h2 className="text-3xl font-bold text-amber-500">제휴 대학 목록</h2>
                    </div>

                    {/* 4행 - 대학 로고들 */}
                    <div className="flex justify-center items-center gap-12 mb-20">
                        <div className="aspect-[4/3] w-32  flex items-center justify-center">
                            <img src="/images/univ_gangwon.png" alt="강원대학교 로고" className="w-full h-full object-contain" />
                        </div>
                        <div className="aspect-[4/3] w-32 flex items-center justify-center">
                            <img src="/images/univ_hallym.png" alt="한림대학교 로고" className="w-full h-full object-contain" />
                        </div>
                        <div className="aspect-[4/3] w-32  flex items-center justify-center">
                            <img src="/images/univ_chuncheon_educastion.png" alt="춘천교대 로고" className="w-full h-full object-contain" />
                        </div>
                    </div>
                </div>
            </div>
        </WebLayout>
    );
};

export default PromotionPartnerPage;
